import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { APP_NAME } from '@repo/shared/common';
import en from './translations/en';

const i18nInstance = i18n.createInstance();

void i18nInstance.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    // Inject the app name into every translation so user-facing strings can
    // reference {{appName}} instead of hardcoding the app name. Single source
    // of truth — change APP_NAME and every string updates.
    defaultVariables: { appName: APP_NAME },
  },
});

export { i18nInstance as i18n };
